import { Identity } from '@/interfaces/user.interface'
import defaultImage from '@assets/img/jpg/image.jpg'

import './card-profile.component.scoped.scss'

interface Props {
  profile: Identity
}

export default ({ profile }: Props) => {
  return (
    <div className="card-profile">
      <div className="avatar-profile">
        <img
          src={profile?.picture}
          alt="profile"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null
            currentTarget.src = defaultImage
          }}
        />
        <div className="icon-social-network display-flex justify-content-center align-items-center p-1">
          <i className="fa-brands fa-instagram position-relative small"></i>
        </div>
      </div>
      <div className="content">
        <span className="username text-bold">@{profile?.username}</span>
        <i className="fa-solid fa-triangle-exclamation mr-1" style={{ color: 'var(--gold)' }}></i>
      </div>
    </div>
  )
}
